import styled from 'styled-components'


export const HeroText = styled.div`
    font-size: 70px;
    font-family: 'Oxygen', sans-serif;
    letter-spacing: 10px;
    font-weight: 600;
    @media(max-width: 768px){
        font-size: 40px;
        letter-spacing: 7px;
    }
`

export const SubHeroText = styled.div`
    font-size: 25px;
    font-family: 'Oxygen', sans-serif;
    font-weight: 500;
    line-height: 30px;
    font-weight: 500;
    text-decoration: underline;
    @media(max-width: 768px){
        font-size: 20px;
    }
`